import React from 'react'
import { Select } from 'antd'

const { Option } = Select

/*export const VAT_VALUES_ENUM = [0, 5, 10, 20]

const vatOptions = VAT_VALUES_ENUM.map((item) => ({
  label: `${item}%`,
  value: item,
}))*/

const VatSelect = ({ value, onChange }) => (
  <Select value={value} onChange={onChange} dropdownMatchSelectWidth={false}>
    <Option value={0}>0%</Option>
    <Option value={5}>5%</Option>
    <Option value={10}>10%</Option>
    <Option value={20}>20%</Option>
    <Option value={22}>22%</Option>
  </Select>
)

export default VatSelect
